/**
 * DIEUKYDIEU.TV - API CONFIGURATION MODULE
 * Controls API base URL, timeout, headers, and Mock / Live switching.
 * Under 300 lines rule compliant.
 */

function isProductionDomain() {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    // Production domain: always use static mockup data for maximum stability and speed
    return host === 'dieukydieu-tv.pages.dev' || host === 'dieukydieu.tv' || host === 'www.dieukydieu.tv';
}

// Check if running in browser and check localStorage / URL query params for easy debugging
function getInitialMockState() {
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('mock')) {
            return urlParams.get('mock') !== 'false';
        }
        const host = window.location.hostname;
        // Staging domain always connects to live backend API
        if (host.includes('staging')) {
            return false;
        }
        const stored = localStorage.getItem('API_USE_MOCK');
        if (stored !== null) {
            return stored !== 'false';
        }
        // Production website defaults to mock data
        if (isProductionDomain()) {
            return true;
        }
    }
    return false; // Staging / Local default: connect to live backend API
}

function getInitialBaseUrl() {
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('apiUrl')) {
            return urlParams.get('apiUrl');
        }
        const stored = localStorage.getItem('API_BASE_URL');
        if (stored) return stored;

        const host = window.location.hostname;
        // Local developer environment with local Go backend
        if (host === 'localhost' || host === '127.0.0.1') {
            return 'http://localhost:8080/api/v1';
        }
    }
    // Default to live Render backend API for all remote domains (dieukydieu.tv, pages.dev, etc.)
    return 'https://dkd-backend.onrender.com/api/v1';
}

export const API_CONFIG = {
    /**
     * Set to true to use local mock data (Current state for testing)
     * Set to false to connect to real backend API endpoints
     */
    USE_MOCK: getInitialMockState(),

    /**
     * Backend API Base URL
     */
    BASE_URL: getInitialBaseUrl(),

    /**
     * Request timeout in milliseconds
     */
    TIMEOUT_MS: 8000,

    /**
     * Default request headers
     */
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },

    /**
     * If backend returns an error or is unreachable, automatically fall back to mock data
     * This guarantees the UI never breaks or turns blank during backend development.
     */
    ENABLE_FALLBACK_ON_ERROR: true,

    /**
     * Simulated network latency (in ms) when USE_MOCK is true (0 to disable)
     */
    MOCK_DELAY_MS: 50
};

/**
 * Switch Mock mode dynamically at runtime
 * @param {boolean} useMock 
 */
export function setUseMock(useMock) {
    API_CONFIG.USE_MOCK = !!useMock;
    if (typeof window !== 'undefined') {
        localStorage.setItem('API_USE_MOCK', String(API_CONFIG.USE_MOCK));
        console.log(`[API Config] Switched USE_MOCK to: ${API_CONFIG.USE_MOCK}`);
    }
}

/**
 * Set custom API Base URL dynamically
 * @param {string} url 
 */
export function setBaseUrl(url) {
    if (!url) return;
    API_CONFIG.BASE_URL = url.replace(/\/+$/, '');
    if (typeof window !== 'undefined') {
        localStorage.setItem('API_BASE_URL', API_CONFIG.BASE_URL);
        console.log(`[API Config] Switched BASE_URL to: ${API_CONFIG.BASE_URL}`);
    }
}
